import { Checkbox, CheckboxOptionType, Col, Row } from "antd";
import { Key } from "react";
import styles from "./GridInputGroup.module.less";

export interface GridCheckboxGroupProps<T extends Key> {
  name: string;
  options: CheckboxOptionType<T>[];
  onChange?: (values: T[]) => void;
  columns: number;
}

export const GridCheckboxGroup = <T extends Key, >({ name, options, onChange, columns }: GridCheckboxGroupProps<T>) => {
  return (
    <Checkbox.Group
      name={name}
      onChange={(values) => onChange ? onChange(values) : undefined}
      style={{ width: "100%" }}
    >
      <Row>
        {options.map((option) => (
          <Col key={option.value} span={24 / columns}>
            <Checkbox key={option.value} value={option.value} className={styles.singleInput}>
              {option.label}
            </Checkbox>
          </Col>
        ))}
      </Row>
    </Checkbox.Group>
  );
};
